import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  bn: {
    // Header
    home: 'হোম',
    about: 'আমাদের সম্পর্কে',
    gallery: 'গ্যালারি',
    temples: 'নিকটবর্তী মন্দির',
    contact: 'যোগাযোগ',
    
    // Hero
    heroTitle: 'নিধিবন হোমস্টে',
    heroSubtitle: 'বৃন্দাবনের হৃদয়ে আপনার আধ্যাত্মিক আশ্রয়',
    heroDescription: 'বৃন্দাবনের প্রধান মন্দিরগুলির পায়ে হাঁটা দূরত্বে শান্তিপূর্ণ এবং পরিষ্কার পরিচ্ছন্ন থাকার ব্যবস্থা অনুভব করুন। ঘরের মতো আরাম।',
    bookNow: 'এখনই যোগাযোগ করুন',
    
    // About
    aboutTitle: 'নিধিবন হোমস্টে সম্পর্কে',
    aboutDescription: 'বৃন্দাবনের কেন্দ্রস্থলে অবস্থিত, নিধিবন হোমস্টে আপনার আধ্যাত্মিক যাত্রার জন্য নিখুঁত আশ্রয় প্রদান করে। আমাদের হোমস্টে সবচেয়ে পবিত্র মন্দিরগুলির হাঁটার দূরত্বে কৌশলগতভাবে অবস্থিত। পরিষ্কার টয়লেট, তাজা বিছানার চাদর এবং কম্বল সহ ঘরের মতো আরামদায়ক পরিবেশ।',
    whyChoose: 'আমাদের কেন বেছে নিবেন?',
    location: 'প্রধান স্থান',
    locationDesc: 'সমস্ত প্রধান মন্দিরের হাঁটার দূরত্বে',
    comfort: 'পরিবার বান্ধব',
    comfortDesc: 'মহিলা এবং শিশুদের জন্য নিরাপদ পরিবেশ',
    peaceful: 'শান্তিপূর্ণ পরিবেশ',
    peacefulDesc: 'পরিবার সহ হোমস্টে - নিরাপদ ও নির্ভরযোগ্য',
    
    // Gallery
    galleryTitle: 'আমাদের হোমস্টে',
    gallerySubtitle: 'আপনার বৃন্দাবনে বাড়ি থেকে দূরে বাড়ি - পরিষ্কার এবং আরামদায়ক',
    
    // Temples
    templesTitle: 'নিকটবর্তী মন্দির',
    templesSubtitle: 'হাঁটার দূরত্বে অবস্থিত বৃন্দাবনের পবিত্র মন্দিরগুলি',
    walkingDistance: 'হাঁটার দূরত্ব',
    
    // Contact
    contactTitle: 'যোগাযোগ করুন',
    contactSubtitle: 'আপনার থাকার জন্য আমাদের সাথে যোগাযোগ করুন',
    phone: 'ফোন',
    email: 'ইমেল',
    address: 'ঠিকানা',
    fullAddress: '৯৮, সিনেমা হল গলি, গোপীনাথ বাজার, ভারতী মিঠাই ওয়ালার কাছে, বৃন্দাবন, মথুরা - ২৮১১২২',
    getDirections: 'দিকনির্দেশ পান',
    
    // Footer
    footerText: '© ২০২৫ নিধিবন হোমস্টে। সর্বস্বত্ব সংরক্ষিত।',
    footerTagline: 'বৃন্দাবনে আপনার আধ্যাত্মিক যাত্রা শুরু হয় এখানে',
  },
  en: {
    // Header
    home: 'Home',
    about: 'About',
    gallery: 'Gallery',
    temples: 'Nearby Temples',
    contact: 'Contact',
    
    // Hero
    heroTitle: 'Nidhiwan Homestay',
    heroSubtitle: 'Your Spiritual Haven in the Heart of Vrindavan',
    heroDescription: 'Experience peaceful and spotlessly clean accommodation in walking distance to all major temples of Vrindavan. Comfort like home.',
    bookNow: 'Contact Now',
    
    // About
    aboutTitle: 'About Nidhiwan Homestay',
    aboutDescription: 'Located in the heart of Vrindavan, Nidhiwan Homestay offers the perfect sanctuary for your spiritual journey. Our homestay is strategically positioned within walking distance of the most sacred temples. Enjoy homely comfort with clean toilets, fresh bedsheets, and blankets.',
    whyChoose: 'Why Choose Us?',
    location: 'Prime Location',
    locationDesc: 'Walking distance to all major temples',
    comfort: 'Family Friendly',
    comfortDesc: 'Safe environment for ladies and children',
    peaceful: 'Peaceful Environment',
    peacefulDesc: 'Family lives on-premises - secure & trustworthy',
    
    // Gallery
    galleryTitle: 'Our Homestay',
    gallerySubtitle: 'Your home away from home in Vrindavan - clean and comfortable',
    
    // Temples
    templesTitle: 'Nearby Temples',
    templesSubtitle: 'Sacred temples of Vrindavan within walking distance',
    walkingDistance: 'Walking Distance',
    
    // Contact
    contactTitle: 'Contact Us',
    contactSubtitle: 'Get in touch for your stay',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    fullAddress: '98, Cinema Hall Gali, Gopinath Bajar, Near Bharti Mithai Wala, Vrindavan, Mathura - 281122',
    getDirections: 'Get Directions',
    
    // Footer
    footerText: '© 2025 Nidhiwan Homestay. All rights reserved.',
    footerTagline: 'Your spiritual journey in Vrindavan starts here',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('bn'); // Default to Bengali

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'bn' : 'en');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
